module.exports = __webpack_public_path__ + "img/home_recom_presentation.adaceabf.png";